import { useRef, useState } from "react";
import api from "@/lib/api";
import { AuthImage } from "@/components/AuthImage";
import { Upload, Loader2, X, Plus } from "lucide-react";

export function MultiPhotoUpload({ value = [], onChange, testId = "multi-photo" }) {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  const handleFiles = async (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    setUploading(true);
    try {
      const uploaded = [];
      for (const file of files) {
        const form = new FormData();
        form.append("file", file);
        const { data } = await api.post("/upload", form, { headers: { "Content-Type": "multipart/form-data" } });
        uploaded.push(data.path);
      }
      onChange([...value, ...uploaded]);
    } catch {
      /* ignore */
    } finally {
      setUploading(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  const remove = (path) => onChange(value.filter((p) => p !== path));

  return (
    <div className="space-y-2">
      <input ref={inputRef} type="file" accept="image/*" multiple className="hidden" onChange={handleFiles} data-testid={`${testId}-input`} />
      <div className="grid grid-cols-3 gap-2">
        {value.map((path) => (
          <div key={path} className="relative h-24 rounded-lg overflow-hidden border border-border group">
            <AuthImage path={path} className="w-full h-full object-cover" />
            <button
              type="button"
              onClick={() => remove(path)}
              className="absolute top-1 right-1 bg-black/60 text-white rounded-full p-1 hover:bg-black/80 transition"
              data-testid={`${testId}-remove`}
            >
              <X className="h-3.5 w-3.5" />
            </button>
          </div>
        ))}
        <button
          type="button"
          onClick={() => inputRef.current?.click()}
          disabled={uploading}
          className="h-24 rounded-lg border-2 border-dashed border-border flex flex-col items-center justify-center gap-1 text-muted-foreground hover:border-primary hover:text-primary transition-colors bg-secondary/40"
          data-testid={`${testId}-button`}
        >
          {uploading ? <Loader2 className="h-5 w-5 animate-spin" /> : value.length ? <Plus className="h-5 w-5" /> : <Upload className="h-5 w-5" />}
          <span className="text-xs font-medium">{uploading ? "Uploading…" : "Add photos"}</span>
        </button>
      </div>
    </div>
  );
}
